import React from 'react';
import './style.scss';

export const PaymentMethodOption = ({
  label,
  iconSrc,
  gateway,
  isSelected = false,
  showChevron = false,
  onClick,
}) => (
  <div
    className={`QRLinkingPaymentMethodOption ${
      isSelected ? 'QRLinkingPaymentMethodOption--selected' : ''
    }`}
    onClick={onClick}
  >
    <div className="QRLinkingPaymentMethodOption__Data">
      <div className="QRLinkingPaymentMethodOption__Data__Logo">
        {iconSrc && (
          <img
            className={`QRLinkingPaymentMethodOption__Data__Logo__${gateway}`}
            alt=""
            src={iconSrc}
          />
        )}
      </div>
      <div className="QRLinkingPaymentMethodOption__Data__Text">{label}</div>
    </div>
    {showChevron && (
      <svg
        className="QRLinkingPaymentMethodOption__Chevron"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M6.75 4.5L11.25 9L6.75 13.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </div>
);

export default PaymentMethodOption;
